/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getPrivateLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/private_labels`);
  }

  updatePrivateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/private_labels`, { labels });
  }
}

export default new ConversationApi();
